import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  /*{
    path: '/desktop',
    component: () => import('../layouts/DesktopLayout.vue'),
    children: [
      {
        path: '/',
        name: 'Desktop',
        component: () => import('../views/ShowResult.vue')
      }
    ]
  },
  {
    path: '/mobile',
    component: () => import('../layouts/MobileLayout.vue'),
    children: [
      {
        path: '/',
        name: 'Mobile',
        component: () => import('../views/ShowResult.vue')
      }
    ]
  }*/
  {
    path: '',
    name: 'ShowResults',
    component: () => import('../views/ShowResult.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
